import { Helmet } from 'react-helmet'
import { makeStyles, Typography } from '@material-ui/core'
import { Link } from 'react-router-dom'

interface IViewProps {
    title: string
    header: React.ReactNode
    returnTo?: {
        url: string,
        text: string,
    },
    children: React.ReactNode
    className?: string
}

const useStyles = makeStyles(theme => ({
    root: {
        padding: '1rem 0 0',
        [theme.breakpoints.up('md')]: {
            padding: '1rem 1.7rem 0',
        }
    },
    heading: {
        padding: '0.5rem 0',
        [theme.breakpoints.up('md')]: {
            padding: '0.5rem 1rem',
        }
    },
    returnNav: {
        padding: '1rem, 0.5rem'
    }
}))


const View = ({ title, header, returnTo, children, className }: IViewProps) => {
    const classes = useStyles()
    return (
        <>
            <Helmet>
                <title>
                    {title} - The Ninja Wars Game
                </title>
            </Helmet>
            <div className={`${classes.root} view-content ${className || ''}`}>
                {header && <Typography className={classes.heading} variant='h1' color='primary'>
                    {header}
                </Typography>}
                {children}
                {returnTo &&
                    <nav>
                        <Link to={returnTo.url}>Return to {returnTo.text}</Link>
                    </nav>}
            </div>

        </>
    )
}

export default View